export const TIMELINE_COLORS = {
  CCM1: "#3B82F6", // Bright blue
  CCM2: "#2563EB", // Rich blue
  CCM3: "#1D4ED8", // Deep blue
  CM3: "#1E40AF", // Navy blue
  PM: "#1E3A8A", // Dark navy

  DCCM: "#8B5CF6", // Vibrant purple
  SPM: "#7C3AED", // Rich purple

  DM: "#0EA5E9", // Sky blue

  VP: "#EAB308", // Golden yellow

  Ops: "#F97316", // Vivid orange

  Payroll: "#22C55E", // Vibrant green
  Paid: "#059669", // Forest green (final success)
  
  Rejected: "#EF4444", // Bright red
};

// Muted variants - softer but still visible for completed states
export const MUTED_TIMELINE_COLORS = {
  CCM1: "#93C5FD", // Soft blue
  CCM2: "#7DD3FC", // Light sky blue
  CCM3: "#60A5FA", // Medium blue
  CM3: "#3B82F6", // Bright blue
  PM: "#2563EB", // Rich blue
  DCCM: "#C4B5FD", // Soft purple
  SPM: "#A78BFA", // Light purple
  DM: "#7DD3FC", // Soft cyan
  VP: "#FDE047", // Soft gold
  Ops: "#FCA5A5", // Soft coral
  Payroll: "#86EFAC", // Soft green
  Paid: "#6EE7B7", // Soft emerald
  Rejected: "#FCA5A5", // Soft red
};

// Active state - MORE vibrant for current step (higher saturation, deeper tones)
export const ACTIVE_TIMELINE_COLORS = {
  CCM1: "#1D4ED8", // Deep blue
  CCM2: "#1E40AF", // Deeper blue
  CCM3: "#1E3A8A", // Navy
  CM3: "#172554", // Dark navy
  PM: "#0F172A", // Almost black navy
  DCCM: "#6D28D9", // Deep purple
  SPM: "#5B21B6", // Deeper purple
  DM: "#0284C7", // Deep cyan
  VP: "#CA8A04", // Deep gold
  Ops: "#EA580C", // Deep orange
  Payroll: "#16A34A", // Deep green
  Paid: "#047857", // Deep emerald
  Rejected: "#DC2626", // Deep red
};

// Pending/future step colors - distinct from completed
export const PENDING_TIMELINE_COLORS = {
  CCM1: "#E0E7FF", // Very light blue
  CCM2: "#E0E7FF",
  CCM3: "#E0E7FF",
  CM3: "#E0E7FF",
  PM: "#E0E7FF",
  DCCM: "#EDE9FE", // Very light purple
  SPM: "#EDE9FE",
  DM: "#E0F2FE", // Very light cyan
  VP: "#FEF9C3", // Very light yellow
  Ops: "#FFEDD5", // Very light orange
  Payroll: "#DCFCE7", // Very light green
  Paid: "#D1FAE5",
  Rejected: "#FEE2E2", // Very light red
};

// Helper function to get the appropriate color based on state
export const getTimelineColor = (
  role: string,
  state: "default" | "muted" | "active" | "pending"
): string => {
  const colorMap = {
    default: TIMELINE_COLORS,
    muted: MUTED_TIMELINE_COLORS,
    active: ACTIVE_TIMELINE_COLORS,
    pending: PENDING_TIMELINE_COLORS,
  };

  return (
    colorMap[state][role as keyof typeof TIMELINE_COLORS] ||
    TIMELINE_COLORS.CCM1
  );
};